import iconConsultant from '@/assets/consultant.png';
import Image from '@/Components/atoms/Image';
import Text from '@/Components/atoms/Text';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './ConsultantCard.scss';
import { Props } from './ConsultantCard.type';

const ConsultantCard: FC<Props> = props => {
  const { t } = useTranslation();

  const list: Array<{ width?: number; title: string; value?: string }> = [
    { width: 116, title: t('GENERAL.PHONE'), value: props.phone },
    { width: 230, title: t('GENERAL.EMAIL'), value: props.email },
  ].filter(i => i.value); // oppure usare un default value con `?? '-'`
  // href="tel:+1234567890" || href="mailto:email@example.com"

  return (
    <div className={`consultant-card ${props.className}`}>
      {props.fullname ? (
        <div className="consultant-card-header">
          <Image
            className="consultant-card-header-img"
            src={props.icon || iconConsultant}
            alt={'Immagine consulente'}
          />
          <div className="consultant-card-header-info">
            <Text className="consultant-card-header-title" type="span" children={props.fullname} />
            <Text
              className="consultant-card-header-subtitle"
              type="span"
              children={t('GENERAL.YOUR_CONSULTANT')}
            />
          </div>
        </div>
      ) : null}
      <div className="consultant-card-list">
        {list.map((item, index) => (
          <div key={index} className="consultant-card-list-item" style={{ minWidth: item.width }}>
            <Text className="consultant-card-list-item-title" type="span" children={item.title} />
            <Text className="consultant-card-list-item-value" type="span" children={item.value!} />
          </div>
        ))}
      </div>
    </div>
  );
};

export { ConsultantCard };
